<template>
  <div
    v-if="isCancelledSubscription && isPro"
    class="tw:hidden tw:md:block tw:md:rounded-xl tw:md:border tw:border-blue-300"
  >
    <ProToPlusReactivationSidebarCard
      :isPriceLoading="isPriceLoading"
      :plusMonthlyPrice="plusMonthlyPrice"
      :annualPrice="annualPrice"
      :proPrice="proPrice"
      :isPricingComparison="isPricingComparison"
      :monthlySavings="monthlySavings"
      @reactivate="reactivate"
    />
  </div>
</template>

<script setup>
import ProToPlusReactivationSidebarCard from '@/components/homePage/sidebar/ProToPlusReactivationSidebarCard.vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { useStudioPlusCampaign } from '@/components/payment/queries'
import { useProToPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useProToPlusReactivation'
import { useProToPlusPricingData } from '@/components/billing/premiumProducts/reactivation/useProToPlusPricingData'

const { isCancelledSubscription, isPro } = useStudioPlusCampaign(selectedAccommodationId)
const { openProToPlusModal } = useProToPlusReactivation()
const { isPriceLoading, plusMonthlyPrice, annualPrice, proPrice, isPricingComparison, monthlySavings } =
  useProToPlusPricingData(selectedAccommodationId)


const reactivate = () => {
  openProToPlusModal(selectedAccommodationId.value, 'homepage_sidebar')
}
</script>
